// wrapper for NProgress widget (loading line at the top of the page which shows progress)
/**
 * @constructor
 */
function ProgressService() {
}
/**
 *
 * @type {{counter: number, initialize: ProgressService.initialize, increment: ProgressService.increment, decrement: ProgressService.decrement}}
 */
ProgressService.prototype = {
    counter: 0,
    /**
     * @function initialize
     * @memberOf ProgressService.prototype
     */
    initialize: function () {
        // NProgress
        this.increment();

        $(window).load(() => {
            this.decrement();
        });
    },
    /**
     * Increments progress data
     * @function increment
     * @memberOf ProgressService.prototype
     */
    increment: function () {
        this.counter++;
        if (this.counter === 1) {
            NProgress.start();
            NProgress.set(0.4);
            this.intervalHandler = setInterval(() => {
                NProgress.inc();
            }, 400);
        }
    },
    /**
     * Decrement progress data
     * @function decrement
     * @memberOf ProgressService.prototype
     */
    decrement: function () {
        setTimeout(() => {
            this.counter--;
            if (this.counter === 0) {
                clearInterval(this.intervalHandler);
                NProgress.done();
            }
        }, 50);
    }
}
/**
 * This module manages any progress representative event
 * @module services/progressService
 * @returns progressService
 */
export default new ProgressService();